import $ from "jquery";
import "fullpage.js";
import fullscreenModalPreventScrolling from "../util/fullscreen_modal_prevent_scrolling";

const SLIDE_TIMER_INTERVAL = 10000;

let slideAnimateTimer;

const animateSlideChange = function () {
  $.fn.fullpage.moveSlideRight();
};

const stopAnimateTimer = function () {
  if (slideAnimateTimer) {
    window.clearTimeout(slideAnimateTimer);
  }
};

const resetAnimateTimer = function () {
  stopAnimateTimer();
  if ($("#fullpage-marketing-home").length) {
    slideAnimateTimer = window.setTimeout(animateSlideChange, SLIDE_TIMER_INTERVAL);
  }
};

const initAnonymousHomeFullpage = function () {
  const anonHomepage = $("#fullpage-marketing-home");

  if (typeof $.fn.fullpage.destroy === "function") {
    $.fn.fullpage.destroy("all");
  }

  if (anonHomepage.length === 0) {
    return;
  }

  anonHomepage.fullpage({
    anchors: [],
    slidesNavigation: true,
    slidesNavPosition: "bottom",
    controlArrows: false,
    //navigation: true,
    //navigationPosition: "top",
    //navigationTooltips: ["section1", "section2", "section3", "section4"],
    css3: true,
    scrollingSpeed: 700,
    autoScrolling: false,
    loopHorizontal: false,
    continuousHorizontal: true,
    continuousHorizontalKey: "QU5ZX1FuR1kyOXVkR2x1ZFc5MWMwaHZjbWw2YjI1MFlXdz01bDY=",
    paddingTop: "72px",
    paddingBottom: "72px",
    recordHistory: false,
    lockAnchors: false,
    fitToSection:false,
    afterRender: resetAnimateTimer,
    onLeave: resetAnimateTimer,
    onSlideLeave: resetAnimateTimer
  });
};

const activateBackToTopLink = function () {
  $(".back-to-top, .back-to-top-tab").click(function (e) {
    e.preventDefault();
    $.fn.fullpage.moveTo("section1");
    $(this).hide();
  });
};

const findPreviousSection = function () {
  // See SECTION_ACTIVE_SEL in fullpage.js
  const prev = $(".fp-section.active").prev(".fp-section");
  return prev;
};

const findNextSection = function () {
  // See SECTION_ACTIVE_SEL in fullpage.js
  const next = $(".fp-section.active").next(".fp-section");
  return next;
};

// Clumsy and gross. Need to find a way to listen for scroll.
const checkWhetherTopOfPage = function (hideFunc, showFunc) {
  let previousSection = $(".fp-section.active")[0];
  let currentSection;
  setInterval(function () {
    currentSection = $(".fp-section.active")[0];
    if (currentSection != previousSection) {
      const prev = findPreviousSection();
      if (!prev.length) {
        // $(".back-to-top").hide();
        hideFunc();
      } else {
        // $(".back-to-top").show(activateBackToTopLink());
        showFunc();
      }
      previousSection = currentSection;
    }
  }, 200);
};

const sectionMap = {
  "section1": "/#section1",
  "section2": "/#section1",
  "section3": "/#section1",
  "section4": "/#section1",
  "section5": "/#section2",
  "section6": "/#section4",
  "section7": "/#section5",
  "section8": "/#section6"
};

const checkWhichSectionToGoBackTo = function () {
  setInterval(function () {
    let currentSection;
    if (findPreviousSection().length && findPreviousSection().attr("class").match(/screenshots-section\d/)) {
      currentSection = `section${parseInt(findPreviousSection().attr("class").match(/screenshots-section\d/)[0].replace("screenshots-section", "")) + 1}`;
    } else {
      currentSection = "section1";
    }
    const path = sectionMap[currentSection];
    $(".back-to-home, .back-to-home-tab").attr("href", path);
  }, 1000);
};

const showBackToTop = function () {
  $(".back-to-top, .back-to-top-tab").show(activateBackToTopLink());
};

const hideBackToTop = function () {
  $(".back-to-top, .back-to-top-tab").hide();
};

const fixVerticalArrows = function () {
  setTimeout(() => {
    const prev = findPreviousSection();
    if (prev.length) {
      $(".previous-section, .next-section").addClass("fixed");
    }
    const next = findNextSection();
    if (!next.length) {
      $(".next-section").hide();
    } else {
      $(".next-section").show();
    }
  }, 800);
};

const unfixVerticalArrows = function () {
  $(".previous-section, .next-section").removeClass("fixed");
};

checkWhetherTopOfPage(hideBackToTop, showBackToTop);
checkWhetherTopOfPage(unfixVerticalArrows, fixVerticalArrows);
checkWhichSectionToGoBackTo();

const previousSectionClicked = function (e) {
  e.preventDefault();
  $.fn.fullpage.moveSectionUp();
  // Only reacts to clicks, not to scroll.
  const prev = findPreviousSection();
  if (!prev.length) {
    $(".back-to-top, .back-to-top-tab").hide();
    $(".previous-section, .next-section").removeClass("fixed");
  }
};

const nextSectionClicked = function (e) {
  e.preventDefault();
  $.fn.fullpage.moveSectionDown();
  // Only reacts to clicks, not to scroll.
  $(".back-to-top").show(activateBackToTopLink());
  $(".previous-section, .next-section").addClass("fixed");
};

const closeModal = function (e) {
  $(e.target.closest(".modal")).removeClass("show").hide();
};

// For some reason the contents of section 8 no longer get wrapped in a tableCell div
const ensureSection8HasTableCell = function () {
  const $section8 = $(".section8");
  if (!$section8.length) return;
  const hasTableCell = !!$section8.children(".fp-tableCell").length;
  if (hasTableCell) return;

  const $tableCellClone = $(".section7").children(".fp-tableCell").first().clone();
  $tableCellClone.empty();
  $tableCellClone.append($section8.children());
  $section8.append($tableCellClone);
};

// Hack to fix errors in layout introduced by fullpage
const correctSection8 = function () {
  if (!$(".section8").length) return;
  $(".section8 .fp-tableCell").append($(".section8 + .inverse.hide-for-mobile"));
  const slidesNavMarginLeft = $(".section8 .fp-slidesNav").css("margin-left").replace(/px/, "");
  $(".section8 .fp-slidesNav").css({ "margin-left": (slidesNavMarginLeft - 45) + "px", "bottom" : "20px" });
};

$(document).on("turbolinks:load", function () {
  initAnonymousHomeFullpage();

  $("a.previous-section").on("click", previousSectionClicked);
  $("a.next-section").on("click", nextSectionClicked);
  $("#accessDeniedModal .close").on("click", closeModal);

  var sections = 7;
  for(var i = 1; i < sections; i++){
    $(".section" + i).addClass("fp-auto-height");
  }

  fullscreenModalPreventScrolling($("#testimonialsModal, #latestInsightsModal, #contactModal, #loginModal, #aboutGwiModal, #loginModal, #requestDemoModal, #accessDeniedModal"));

  ensureSection8HasTableCell();
  correctSection8();
});

$(document).on("show.bs.modal", function () {
  if ($.fn.fullPage) {
    $.fn.fullpage.setAllowScrolling(false);
    $.fn.fullpage.setKeyboardScrolling(false);
  }
});

$(document).on("hide.bs.modal", function () {
  if ($.fn.fullPage) {
    $.fn.fullpage.setAllowScrolling(true);
    $.fn.fullpage.setKeyboardScrolling(true);
  }
});
